// extracted by mini-css-extract-plugin
export default {"icon":"Preload_icon__COD6K"};